import React from 'react';
import { useClientTheme } from '../../contexts/ThemeContext';

export default function ThemeLogo({ 
  className = "", 
  size = "default",
  showText = false,
  variant = "default" 
}) {
  const { logoPath, brandName, brandShortName, isLoading } = useClientTheme();
  
  // Size configurations
  const sizeClasses = {
    small: "h-6 w-auto",
    default: "h-8 w-auto", 
    large: "h-12 w-auto",
    xlarge: "h-16 w-auto"
  };

  const textSizeClasses = {
    small: "text-sm",
    default: "text-base",
    large: "text-lg", 
    xlarge: "text-xl"
  };

  if (isLoading) {
    return (
      <div className={`${sizeClasses[size]} bg-gray-200 dark:bg-gray-700 rounded animate-pulse ${className}`}>
        <div className="w-24 h-full bg-gray-300 dark:bg-gray-600 rounded"></div>
      </div>
    );
  }

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <img 
        src={logoPath}
        alt={`${brandShortName} Logo`}
        className={`${sizeClasses[size]} object-contain`}
        onError={(e) => {
          // Fallback to default logo if theme logo fails to load
          e.target.src = '/images/logos/logo-henddu.png';
        }}
      />
      
      {showText && (
        <span className={`font-semibold text-gray-900 dark:text-white ${textSizeClasses[size]}`}>
          {variant === "short" ? brandShortName : brandName}
        </span>
      )}
    </div>
  );
}

// Convenient pre-configured logo components
export const HeaderLogo = ({ className = "" }) => (
  <ThemeLogo 
    size="default" 
    showText={true} 
    variant="short"
    className={className}
  />
);

export const NavLogo = ({ className = "" }) => (
  <ThemeLogo 
    size="large" 
    showText={false}
    className={className}
  />
);

export const LoginLogo = ({ className = "" }) => (
  <ThemeLogo 
    size="xlarge" 
    showText={true} 
    variant="full"
    className={`justify-center ${className}`}
  />
);